<template>
  <app-action-bar
    :menu-items="actionBarItems"
    :selected-items="selectedTasks"
    :selected-items-label-path="selectedItemsLabelPath"
    data-locator="multi-select-bar" 
    @clear-selection="onClearSelection"
  >
    <app-action-bar-list-item 
      v-for="item in actionBarItems"
      :item="item"
      :key="item.name"
    />
  </app-action-bar>

  <ContactResponsibleDialog
    v-if="contactResponsibleDialogIsOpen"
    :mnemo="roomMnemo"
    :tasks="selectedTasks"
    @close="contactResponsibleDialogIsOpen = false"
  />

  <ChecklistDeleteSelectionDialog
      v-if="isDeleteSelectionDialogOpened"
      @close="isDeleteSelectionDialogOpened = false"
  />

  <ChecklistStatusDialog
    v-if="isStatusDialogOpened"
    :mnemo="roomMnemo"
    :tasks="selectedTasks"
    @clear-selection="onClearSelection"
    @close="isStatusDialogOpened = false" 
  />
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

import ChecklistDeleteSelectionDialog from '@/project/checklist/dialogs/ChecklistDeleteSelectionDialog.vue'
import ChecklistStatusDialog from '@/project/checklist/dialogs/ChecklistStatusDialog.vue'
import ContactResponsibleDialog from '@/project/checklist/dialogs/ContactResponsibleDialog.vue'
import { CLEAR_ITEMS_SELECTION } from '@/store/modules/checklist/action_types'
import { SET_SHARE_TASKS_DIALOG } from '@/store/modules/checklist/mutation_types'

const TRANSLATION_KEY_PREFIX = 'project.checklist.ChecklistActionBar'

export default {
  name: 'ChecklistActionBar',
  components: {
    ChecklistDeleteSelectionDialog,
    ChecklistStatusDialog,
    ContactResponsibleDialog,
  },
  data () {
    return {
      contactResponsibleDialogIsOpen: false,
      isDeleteSelectionDialogOpened: false,
      isStatusDialogOpened: false,
      TRANSLATION_KEY_PREFIX,
    }
  },
  computed: {
    ...mapGetters('checklist', ['selectedTasks', 'isValidatorOfAllSelectedTasks', 'isResponsibleOfAllSelectedTasks', 'allSelectedTasksHaveNoResponsibles']),
    ...mapGetters('room', ['isCurrentUserPm', 'roomMnemo']),
    actionBarItems () {
      return [
        {
          action: this.openStatusDialog,
          icon: 'circle-dashed',
          name: 'status',
          title: this.$t(`${TRANSLATION_KEY_PREFIX}.status`),
          locatorValue: 'status-button',
          disabled: !this.isCurrentUserPm && !this.isValidatorOfAllSelectedTasks && !this.isResponsibleOfAllSelectedTasks,
          disabledTooltip: this.$t(`${TRANSLATION_KEY_PREFIX}.statusDisabledTooltip`),
        },
        {
          action: this.openShareSelectionDialog,
          icon: 'user-lock',
          name: 'share',
          title: this.$t('common.share'),
          locatorValue: 'share-button',
          hidden: !this.isCurrentUserPm,
        },
        {
          action: this.openContactResponsiblesDialog,
          icon: 'envelope',
          name: 'contact-responsibles',
          title: this.$t(`${TRANSLATION_KEY_PREFIX}.contactResponsibles`),
          locatorValue: 'contact-responsibles-button',
          hidden: !this.isCurrentUserPm || this.allSelectedTasksHaveNoResponsibles,
        },
        {
          action: this.openDeleteDialog,
          icon: 'trash-alt',
          name: 'delete',
          title: this.$t('common.delete'),
          locatorValue: 'delete-bar-item',
          style: 'text-error',
          variant: 'danger',
          hidden: !this.isCurrentUserPm,
        },
      ]
    },
    selectedItemsLabelPath () {
      return `${TRANSLATION_KEY_PREFIX}.selectedItemsLabel`
    },
  },
  beforeUnmount () {
    this.CLEAR_ITEMS_SELECTION()
  },
  methods: {
    ...mapActions('checklist', [CLEAR_ITEMS_SELECTION]),
    ...mapMutations('checklist', [SET_SHARE_TASKS_DIALOG]),
    onClearSelection () {
      this.CLEAR_ITEMS_SELECTION()
    },
    openDeleteDialog () {
      this.isDeleteSelectionDialogOpened = true
    },
    openStatusDialog () {
      this.isStatusDialogOpened = true
    },
    openShareSelectionDialog () {
      this.SET_SHARE_TASKS_DIALOG({
        isOpen: true,
        tasksToShare: this.selectedTasks,
      })
    },
    openContactResponsiblesDialog () {
      this.contactResponsibleDialogIsOpen = true
    },
  },
}
</script>
